import { render, staticRenderFns } from "./MisSugerenciasPage.vue?vue&type=template&id=1da7ce1e&scoped=true"
import script from "./MisSugerenciasPage.js?vue&type=script&lang=js&external"
export * from "./MisSugerenciasPage.js?vue&type=script&lang=js&external"
import style0 from "./MisSugerenciasPage.vue?vue&type=style&index=0&id=1da7ce1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da7ce1e",
  null
  
)

export default component.exports